<template>
  <svg width="84" height="100" viewBox="0 0 84 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M37.5274 65.8198H12.3779V71.9561H37.5274V65.8198Z" fill="white" fill-opacity="0.2"/>
    <path d="M37.5274 56.0288H12.3779V62.1651H37.5274V56.0288Z" fill="white" fill-opacity="0.2"/>
    <path d="M62.6768 11.2061H12.3779V17.3423H62.6768V11.2061Z" fill="white" fill-opacity="0.2"/>
    <path d="M62.6768 22.52H12.3779V28.6563H62.6768V22.52Z" fill="white" fill-opacity="0.2"/>
    <path d="M37.5274 33.3997H12.3779V39.5359H37.5274V33.3997Z" fill="white" fill-opacity="0.2"/>
    <path d="M74.5084 51.4597V42.1252H68.341V51.4597H58.8506V57.596H68.341V67.1476H74.5084V57.596H84V51.4597H74.5084Z" fill="white" fill-opacity="0.2"/>
    <path d="M55.4832 53.9843C55.4832 44.9382 62.8803 37.5784 71.9723 37.5784H75.056V5.67971C75.056 2.54777 72.4953 0 69.3475 0H5.70855C2.5607 0 0 2.54777 0 5.67971V88.7535L8.31119 99.9988L18.4677 92.4917L27.9605 99.498L37.4411 92.5199L46.9117 99.4809L56.4144 92.4573L66.5697 99.9521L75.0548 88.3743V70.3877H71.9711C62.8791 70.3877 55.4819 63.0279 55.4819 53.9818L55.4832 53.9843ZM68.8886 86.3763L65.2511 91.3393L56.4132 84.8165L46.9031 91.8462L37.4398 84.8913L27.9667 91.8633L18.4664 84.8508L9.61004 91.397L6.16863 86.7408V6.13625H68.8899V31.6495C57.8502 33.1505 49.317 42.5942 49.317 53.9843C49.317 65.3744 57.8502 74.8181 68.8899 76.319V86.3775L68.8886 86.3763Z" fill="white" fill-opacity="0.2"/>
  </svg>
</template>

<script>
  export default {
    name: 'OrderStatusNewIcon',
  }
</script>

<style scoped>

</style>
